import { css } from 'styled-components';
import { themeGet } from './themeGet/get.js';
import { pxToRem } from '../spacing/utils.js';

var interactiveTransition = css(["transition-property:background,border,color,box-shadow,outline,opacity;transition-duration:0.25s;transition-timing-function:ease;[data-icon='falcon']{transition-property:inherit;transition-duration:inherit;transition-timing-function:inherit;}"]);
/**
 * Sets the text color to the AI gradient
 * @param shade The shade of the AI color
 */
var aiTextColor = function aiTextColor(shade) {
  return css(["background-image:", ";background-clip:text;-webkit-text-fill-color:transparent;color:", ";"], themeGet("colors.ai." + shade), themeGet('colors.blue.500'));
};
/**
 * Sets the background color to the AI gradient
 * @param shade The shade of the AI color
 */
var aiBackgroundColor = function aiBackgroundColor(shade) {
  return css(["background-image:", ";"], themeGet("colors.ai." + shade));
};
/**
 * Sets the border color to the AI gradient using CSS `::before` pseudo element
 * @param shade The shade of the AI color
 *
 * In order to make it work, `<AiBorderStackingOrderGuard />` **must** wrap the component that has the `aiBorderColor` ruleset applied.
 */
var aiBorderColor = function aiBorderColor(shade) {
  return css(["position:relative;border:", " solid transparent;background-clip:padding-box;overflow:visible;&::before{content:'';position:absolute;top:0;right:0;bottom:0;left:0;z-index:-1;margin:-", ";border-radius:inherit;background-image:", ";}"], pxToRem(1), pxToRem(1), themeGet("colors.ai." + shade));
};
/**
 * This component **must** wrap a component that has the `aiBorderColor` CSS ruleset applied.
 */
var aiBorderStackingOrderGuard = css(["position:relative;z-index:0;"]);

export { aiBackgroundColor, aiBorderColor, aiBorderStackingOrderGuard, aiTextColor, interactiveTransition };
